import { useState as G, useEffect as A, useMemo as ne } from "react";
import "react/jsx-runtime";
import { initialize as te, whenAvailable as re, isFeatureEnabled as oe } from "@vp/ab-reader";
class O extends Error {
}
O.prototype.name = "InvalidTokenError";
function ie(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (n, t) => {
    let r = t.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function se(e) {
  let n = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (n.length % 4) {
    case 0:
      break;
    case 2:
      n += "==";
      break;
    case 3:
      n += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return ie(n);
  } catch {
    return atob(n);
  }
}
function ae(e, n) {
  if (typeof e != "string")
    throw new O("Invalid token specified: must be a string");
  n || (n = {});
  const t = n.header === !0 ? 0 : 1, r = e.split(".")[t];
  if (typeof r != "string")
    throw new O(`Invalid token specified: missing part #${t + 1}`);
  let i;
  try {
    i = se(r);
  } catch (s) {
    throw new O(`Invalid token specified: invalid base64 for part #${t + 1} (${s.message})`);
  }
  try {
    return JSON.parse(i);
  } catch (s) {
    throw new O(`Invalid token specified: invalid json for part #${t + 1} (${s.message})`);
  }
}
const ce = "https://physical-products-newrelic-logger.large-assortment.vpsvc.com";
class ue {
  constructor(n) {
    var p;
    const {
      applicationId: t,
      requestor: r,
      sessionId: i,
      canonicalId: s,
      authorizationHeader: o,
      entityName: c,
      domain: l,
      product: v,
      page: d,
      environment: _,
      version: a
    } = n;
    this.applicationId = t ?? "", this.entityName = c ?? "", this.requestor = r ?? "", this.sessionId = i ?? "", this.canonicalId = s ?? "", this.authorizationHeader = o ?? "", this.userAgent = ((p = window == null ? void 0 : window.navigator) == null ? void 0 : p.userAgent) ?? "", this.domain = l ?? "", this.product = v ?? "", this.page = d ?? "", this.environment = _ ?? "", this.version = a ?? "";
  }
  async error(n, t, r) {
    if (!this.canSendLog()) {
      console.error(n, t, r);
      return;
    }
    await this.log(n, "ERROR", { error: t, ...r });
  }
  async warn(n, t) {
    if (!this.canSendLog()) {
      console.warn(n, t);
      return;
    }
    await this.log(n, "WARNING", { ...t });
  }
  async info(n, t) {
    if (!this.canSendLog()) {
      console.info(n, t);
      return;
    }
    await this.log(n, "INFO", { ...t });
  }
  async log(n, t, r) {
    const i = {
      authorizationHeader: this.authorizationHeader,
      requestor: this.requestor,
      applicationId: this.applicationId,
      body: {
        level: t,
        message: n,
        applicationId: this.applicationId,
        entityName: this.entityName,
        domain: this.domain,
        context: {
          sessionId: this.sessionId,
          canonicalId: this.canonicalId,
          userAgent: this.userAgent,
          product: this.product,
          page: this.page,
          environment: this.environment,
          version: this.version,
          ...r
        }
      }
    };
    await this.tryToSendLog(i);
  }
  async tryToSendLog(n) {
    try {
      await this.sendLog(n);
    } catch (t) {
      console.error("Error sending logs to New Relic", t == null ? void 0 : t.message);
    }
  }
  canSendLog() {
    return !!this.authorizationHeader && (!!this.applicationId || !!this.entityName) && !!this.canonicalId && !!this.requestor;
  }
  async sendLog({
    requestor: n,
    authorizationHeader: t,
    applicationId: r,
    body: i
  }) {
    const s = `${ce}/v1/log/${r}?requestor=${n}`, o = await fetch(s, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: t
      },
      body: JSON.stringify(i)
    });
    if (!o.ok) {
      const c = await o.text();
      throw new Error(c);
    }
    return await o.json();
  }
}
const de = (e) => new ue(e), le = ({
  authorizationHeader: e,
  canonicalId: n,
  applicationVersion: t,
  applicationId: r,
  requestor: i,
  entityName: s,
  domain: o,
  page: c,
  isDevelopment: l
}) => de({
  applicationId: r,
  requestor: i ?? "My Account Monorepo",
  authorizationHeader: e,
  entityName: s,
  canonicalId: n,
  sessionId: void 0,
  // TODO: Add session id if needed
  domain: o ?? "prdct",
  product: "my-account",
  page: c ?? "undefined page",
  environment: l ? "development" : "production",
  version: t
});
var f = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function pe(e) {
  if (e.__esModule)
    return e;
  var n = e.default;
  if (typeof n == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    t.prototype = n.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), t;
}
const ge = "@vp/google-one-tap", ve = "2.0.1", _e = "./index.js", he = "./index.mjs", me = "./index.d.ts", Ce = {
  ".": {
    import: "./index.mjs",
    require: "./index.js",
    types: "./index.d.ts"
  }
}, Ie = {
  react: ">=17 <20",
  "react-dom": ">=17 <20",
  "@vp/auth": "^6.1.187",
  "@vp/ab-reader": "^3.3.3"
}, we = {
  name: ge,
  version: ve,
  main: _e,
  module: he,
  types: me,
  exports: Ce,
  peerDependencies: Ie
};
var x = { exports: {} };
/*! js-cookie v3.0.5 | MIT */
(function(e, n) {
  (function(t, r) {
    e.exports = r();
  })(f, function() {
    function t(o) {
      for (var c = 1; c < arguments.length; c++) {
        var l = arguments[c];
        for (var v in l)
          o[v] = l[v];
      }
      return o;
    }
    var r = {
      read: function(o) {
        return o[0] === '"' && (o = o.slice(1, -1)), o.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      },
      write: function(o) {
        return encodeURIComponent(o).replace(
          /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
          decodeURIComponent
        );
      }
    };
    function i(o, c) {
      function l(d, _, a) {
        if (!(typeof document > "u")) {
          a = t({}, c, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), d = encodeURIComponent(d).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
          var p = "";
          for (var m in a)
            a[m] && (p += "; " + m, a[m] !== !0 && (p += "=" + a[m].split(";")[0]));
          return document.cookie = d + "=" + o.write(_, d) + p;
        }
      }
      function v(d) {
        if (!(typeof document > "u" || arguments.length && !d)) {
          for (var _ = document.cookie ? document.cookie.split("; ") : [], a = {}, p = 0; p < _.length; p++) {
            var m = _[p].split("="), T = m.slice(1).join("=");
            try {
              var w = decodeURIComponent(m[0]);
              if (a[w] = o.read(T, w), d === w)
                break;
            } catch {
            }
          }
          return d ? a[d] : a;
        }
      }
      return Object.create(
        {
          set: l,
          get: v,
          remove: function(d, _) {
            l(
              d,
              "",
              t({}, _, {
                expires: -1
              })
            );
          },
          withAttributes: function(d) {
            return i(this.converter, t({}, this.attributes, d));
          },
          withConverter: function(d) {
            return i(t({}, this.converter, d), this.attributes);
          }
        },
        {
          attributes: { value: Object.freeze(c) },
          converter: { value: Object.freeze(o) }
        }
      );
    }
    var s = i(r, { path: "/" });
    return s;
  });
})(x);
var z = x.exports;
const Ee = /* @__PURE__ */ fe(z);
var N = {};
(function(e) {
  e.getEuMembers = function() {
    return ["BE", "BG", "CZ", "DK", "DE", "EE", "IE", "EL", "ES", "FR", "HR", "IT", "CY", "LV", "LT", "LU", "HU", "MT", "NL", "AT", "PL", "PT", "RO", "SI", "SK", "FI", "SE"];
  }, e.isEuMember = function(n) {
    return e.getEuMembers().indexOf(n.toUpperCase()) != -1;
  };
})(N);
var $ = function() {
  var e = (typeof window < "u" || void 0) && window.location && window.location.hostname;
  if (!e || e.length === 0)
    throw new Error("Hostname could not be determined for the current document.");
  return e;
}, B = function() {
  var e = (typeof window < "u" || void 0) && window.location && window.location.pathname;
  return e || "/";
}, Oe = function(e) {
  if (!e || e.length === 0)
    throw new Error("Domain must be specified");
  var n = e.split(".");
  if (n.length < 2)
    throw new Error("Domain '" + e + "' does hot have the right format.");
  var t = n.pop();
  return t;
}, ye = "vista.com", F = function(e, n) {
  var t;
  switch (e === "localhost" ? t = "IE" : e === ye ? t = n === "/" ? "us" : n.substr(1, 2) : t = Oe(e), t.toLowerCase()) {
    case "pt":
      return "PT";
    case "ie":
      return "IE";
    case "es":
      return "ES";
    case "in":
      return "IN";
    case "jp":
      return "JP";
    case "com":
    case "us":
      return "US";
    case "fr":
      return "FR";
    case "it":
      return "IT";
    case "uk":
      return "GB";
    case "de":
      return "DE";
    case "nl":
      return "NL";
    case "dk":
      return "DK";
    case "se":
      return "SE";
    case "at":
      return "AT";
    case "no":
      return "NO";
    case "fi":
      return "FI";
    case "be":
      return "BE";
    case "sg":
      return "SG";
    case "nz":
      return "NZ";
    case "au":
      return "AU";
    case "ca":
      return "CA";
    case "ch":
      return "CH";
  }
  throw new Error("Unknown country for host " + e + " and path " + n);
};
function Pe(e) {
  var n = e.toLowerCase();
  return n.startsWith("/fr") || n.startsWith("/fr-be") ? "fr-BE" : "nl-BE";
}
function Se(e) {
  var n = e.toLowerCase();
  return n.startsWith("/es") || n.startsWith("/us/es") ? "es-US" : "en-US";
}
function Te(e) {
  var n = e.toLowerCase();
  return n.startsWith("/fr") || n.startsWith("/ca/fr") ? "fr-CA" : "en-CA";
}
function be(e) {
  var n = e.toLowerCase();
  return n.startsWith("/fr") ? "fr-CH" : n.startsWith("/it") ? "it-CH" : "de-CH";
}
var De = function(e, n) {
  var t = F(e, n);
  switch (t.toUpperCase()) {
    case "PT":
      return "pt-PT";
    case "IE":
      return "en-IE";
    case "ES":
      return "es-ES";
    case "IN":
      return "en-IN";
    case "US":
      return Se(n);
    case "GB":
      return "en-GB";
    case "FR":
      return "fr-FR";
    case "IT":
      return "it-IT";
    case "DE":
      return "de-DE";
    case "NL":
      return "nl-NL";
    case "DK":
      return "da-DK";
    case "SE":
      return "sv-SE";
    case "AT":
      return "de-AT";
    case "NO":
      return "nb-NO";
    case "FI":
      return "fi-FI";
    case "BE":
      return Pe(n);
    case "SG":
      return "en-SG";
    case "JP":
      return "ja-JP";
    case "NZ":
      return "en-NZ";
    case "AU":
      return "en-AU";
    case "CA":
      return Te(n);
    case "CH":
      return be(n);
  }
  throw new Error("Unknown culture for host " + e + " and path " + n);
}, Ge = function() {
  var e = $(), n = B();
  return De(e, n);
}, H = function() {
  var e = $(), n = B();
  return F(e, n);
};
const Ae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getCurrentCountry: H,
  getCurrentCulture: Ge
}, Symbol.toStringTag, { value: "Module" }));
var M;
(function(e) {
  e[e.None = 0] = "None", e[e.GDPR = 1] = "GDPR", e[e.CCPA = 2] = "CCPA";
})(M || (M = {}));
function Ne(e) {
  return e ? (e = e.toLowerCase(), N.isEuMember(e) || e === "ch" || e === "no" || e === "gb") : !1;
}
function Re() {
  var e, n;
  try {
    n = H();
  } catch {
    return !0;
  }
  var t = !!(!((e = window == null ? void 0 : window.consentManager) === null || e === void 0) && e.openConsentManager), r = Ne(n) || t && n.toLowerCase() !== "us";
  return r;
}
function Le() {
  var e = Ee.get("tracking-preferences");
  return e ? JSON.parse(e) : {};
}
function ke() {
  var e = Le();
  return e && e.custom && e.consent !== !1 ? !1 : Re();
}
var h = {};
const je = /* @__PURE__ */ pe(Ae);
var q = {}, V = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Regulations = void 0, function(n) {
    n[n.None = 0] = "None", n[n.GDPR = 1] = "GDPR", n[n.CCPA = 2] = "CCPA";
  }(e.Regulations || (e.Regulations = {}));
})(V);
(function(e) {
  var n = f && f.__createBinding || (Object.create ? function(r, i, s, o) {
    o === void 0 && (o = s);
    var c = Object.getOwnPropertyDescriptor(i, s);
    (!c || ("get" in c ? !i.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
      return i[s];
    } }), Object.defineProperty(r, o, c);
  } : function(r, i, s, o) {
    o === void 0 && (o = s), r[o] = i[s];
  }), t = f && f.__exportStar || function(r, i) {
    for (var s in r)
      s !== "default" && !Object.prototype.hasOwnProperty.call(i, s) && n(i, r, s);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), t(V, e);
})(q);
var W = {}, C = {};
Object.defineProperty(C, "__esModule", { value: !0 });
C.overrides = C.AllAllowedPreferences = C.DefaultGdprPreferences = void 0;
C.DefaultGdprPreferences = {
  functional: !0,
  advertising: !1,
  sessionReplay: !1,
  dataSale: !0
};
C.AllAllowedPreferences = {
  functional: !0,
  advertising: !0,
  sessionReplay: !0,
  dataSale: !0
};
C.overrides = {
  ie: {
    functional: !1
  },
  pt: {
    functional: !1
  },
  no: {
    functional: !1
  }
};
(function(e) {
  var n = f && f.__createBinding || (Object.create ? function(r, i, s, o) {
    o === void 0 && (o = s);
    var c = Object.getOwnPropertyDescriptor(i, s);
    (!c || ("get" in c ? !i.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
      return i[s];
    } }), Object.defineProperty(r, o, c);
  } : function(r, i, s, o) {
    o === void 0 && (o = s), r[o] = i[s];
  }), t = f && f.__exportStar || function(r, i) {
    for (var s in r)
      s !== "default" && !Object.prototype.hasOwnProperty.call(i, s) && n(i, r, s);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), t(C, e);
})(W);
var S = f && f.__assign || function() {
  return S = Object.assign || function(e) {
    for (var n, t = 1, r = arguments.length; t < r; t++) {
      n = arguments[t];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, S.apply(this, arguments);
}, Me = f && f.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(h, "__esModule", { value: !0 });
var J = h.onCookieConsentProvided = h.isCookieConsentPending = h.getCookieConsent = h.applyOverrides = h.getRegulations = void 0, Ue = Me(z), xe = N, R = je, I = q, y = W;
function Y(e) {
  return e ? (e = e.toLowerCase(), (0, xe.isEuMember)(e) || e === "ch" || e === "no" || e === "gb") : !1;
}
function ze() {
  var e, n;
  try {
    n = (0, R.getCurrentCountry)();
  } catch {
    return !0;
  }
  var t = !!(!((e = window == null ? void 0 : window.consentManager) === null || e === void 0) && e.openConsentManager), r = Y(n) || t && n.toLowerCase() !== "us";
  return r;
}
function K() {
  var e;
  try {
    e = (0, R.getCurrentCountry)();
  } catch {
    return I.Regulations.GDPR;
  }
  return e ? (e = e.toLowerCase(), e === "us" ? I.Regulations.CCPA : Y(e) ? I.Regulations.GDPR : I.Regulations.None) : I.Regulations.None;
}
h.getRegulations = K;
function Z() {
  var e = Ue.default.get("tracking-preferences");
  return e ? JSON.parse(e) : {};
}
function U(e) {
  var n, t;
  return e.version === 4 ? (t = (n = e.custom) === null || n === void 0 ? void 0 : n.datasale) !== null && t !== void 0 ? t : !0 : !(e.destinations && e.destinations.All === !0 && e.destinations["Facebook Pixel"] === !1);
}
function X(e, n) {
  n === void 0 && (n = y.overrides);
  var t;
  try {
    t = (0, R.getCurrentCountry)();
  } catch {
    return e;
  }
  if (n && Object.keys(n).includes(t)) {
    var r = Object(e);
    return Object.keys(n[t]).forEach(function(i) {
      r[i] = Object(n[t])[i];
    }), r;
  }
  return e;
}
h.applyOverrides = X;
function $e() {
  var e = K(), n = Z();
  if (e === I.Regulations.None)
    return {
      hasConsent: !1,
      categories: y.AllAllowedPreferences
    };
  if (e === I.Regulations.CCPA)
    return {
      hasConsent: !1,
      categories: S(S({}, y.AllAllowedPreferences), { dataSale: U(n) })
    };
  if (n.custom) {
    var t = n.custom, r = t.functional, i = t.advertising, s = t.sessionreplay, o = {
      hasConsent: n.consent !== !1,
      categories: {
        functional: r ?? !0,
        advertising: i ?? !1,
        sessionReplay: s ?? !1,
        dataSale: U(n)
      }
    };
    return o;
  }
  return {
    hasConsent: !1,
    categories: X(y.DefaultGdprPreferences)
  };
}
h.getCookieConsent = $e;
function Be() {
  var e = Z();
  return e && e.custom && e.consent !== !1 ? !1 : ze();
}
h.isCookieConsentPending = Be;
function Fe(e, n) {
  if (n === void 0 && (n = !0), typeof e == "function") {
    var t = function(r) {
      var i = r;
      e(i.detail), n && window.removeEventListener("cookieConsentProvided", t);
    };
    window.addEventListener("cookieConsentProvided", t);
  }
}
J = h.onCookieConsentProvided = Fe;
const He = "google_one_tap_feature_flag", qe = "https://accounts.google.com/gsi/client", Ve = "google-one-tap-script", We = "Google One Tap", Je = "vista-google-one-tap", D = "trackingReady", Ye = () => {
  const [e, n] = G(!1);
  return A(() => {
    const t = () => {
      ke() || n(!0);
    };
    if (window.trackingInitialized)
      t();
    else {
      const i = () => {
        t(), window.removeEventListener(
          D,
          i
        );
      };
      return window.addEventListener(D, i), () => {
        window.removeEventListener(
          D,
          i
        );
      };
    }
    J(() => {
      n(!0);
    });
  }, []), e;
}, Ke = () => {
  const [e, n] = G(!1);
  return A(() => {
    e || (te(), re((t) => {
      t && n(oe(He));
    }));
  }, [e]), e;
};
var P = /* @__PURE__ */ ((e) => (e.IS_NOT_DISPLAYED = "is_not_displayed", e.IS_SKIPPED_MOMENT = "is_skipped_moment", e.IS_DISMISSED_MOMENT = "is_dismissed_moment", e))(P || {});
const Ze = (e) => e ? "343394417575-hffh8b7bq2r9kucidsd7hh33j97028h4.apps.googleusercontent.com" : "698509477252-q60d4qh2nsd0h86amgpm25m11lp99b0v.apps.googleusercontent.com", Xe = (e) => e ? "1120343661" : "1120343659";
function Qe() {
  return typeof navigator < "u" && navigator.credentials !== void 0 && typeof navigator.credentials.get == "function" && "FederatedCredential" in window;
}
const en = async (e) => {
  try {
    const n = await fetch("https://oauth2.googleapis.com/tokeninfo", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        id_token: e
      })
    });
    return n.ok ? (await n.json()).email_verified : !1;
  } catch {
    return !1;
  }
}, cn = (e) => {
  var L, k;
  const [n, t] = G(!1), { isDevelopment: r, onCredentialResponse: i, onNotificationEvent: s, authData: o, disableCoolDown: c } = e, l = (L = o == null ? void 0 : o.auth) == null ? void 0 : L.getCanonicalId(), v = (k = o == null ? void 0 : o.auth) == null ? void 0 : k.getAuthorizationHeader(), d = o == null ? void 0 : o.isIdentityInitialized, _ = Xe(r || !1), a = ne(() => {
    if (d && l && v) {
      const b = we.version;
      return le({
        authorizationHeader: v,
        applicationId: _,
        canonicalId: l,
        applicationVersion: b,
        requestor: We,
        page: (window == null ? void 0 : window.location.href) ?? Je,
        isDevelopment: r ?? !1
      });
    }
  }, [d, l, v, _, r]), p = Ke(), m = (o == null ? void 0 : o.auth) && (o == null ? void 0 : o.isIdentityInitialized) && !(o != null && o.isSignedIn), T = Ye(), w = m && !n && p && T, E = Qe();
  return A(() => {
    const b = async (g) => {
      try {
        if (o != null && o.auth) {
          const u = ae(g.credential, {});
          i && i(u.email), await en(g.credential) || await (a == null ? void 0 : a.warn("email_verified is false returned by Google with email", {
            email: u.email,
            anonymousShopperId: l
          })), r && await (a == null ? void 0 : a.info("Anonymous users signing in using Google one tap", {
            email: u.email,
            anonymousShopperId: l
          })), o.auth.signIn([], [], { enableGoogleOneTap: !0, enforcedEmail: u.email });
        }
      } catch (u) {
        a == null || a.error("Error calling auth.signIn", u);
      }
    }, j = () => {
      const g = Ve;
      if (document.getElementById(g))
        return;
      const u = document.createElement("script");
      u.id = g, u.src = qe, u.async = !0, u.defer = !0, u.onload = Q, u.onerror = async () => {
        console.error("Failed to load Google One Tap script."), r && await (a == null ? void 0 : a.log("Failed to load Google One Tap script.", "ERROR"));
      }, document.head.appendChild(u);
    }, Q = async () => {
      if (typeof google > "u" || !(google != null && google.accounts) || !(google != null && google.accounts.id)) {
        await (a == null ? void 0 : a.log("Google One Tap initialization failed.", "ERROR"));
        return;
      }
      google.accounts.id.initialize({
        client_id: Ze(r),
        callback: b,
        auto_select: !1,
        cancel_on_tap_outside: !1,
        use_fedcm_for_prompt: E
      }), ee();
    }, ee = () => {
      google.accounts.id.prompt(async (g) => {
        if (!E && g.isNotDisplayed()) {
          const u = g.getNotDisplayedReason();
          r && await (a == null ? void 0 : a.info(
            `Not displayed (user not eligible, blocked, network issue): ${u}`
          )), s && s(P.IS_NOT_DISPLAYED, u);
        }
        if (g.isSkippedMoment()) {
          const u = E ? "" : g.getSkippedReason();
          r && await (a == null ? void 0 : a.info(
            `Skipped by the system (recent user interaction, preferences or settings): ${u}`
          )), s && s(P.IS_SKIPPED_MOMENT, u);
        }
        if (g.isDismissedMoment()) {
          const u = g.getDismissedReason();
          r && await (a == null ? void 0 : a.info(
            `Dismissed by user (manual closure, clicked outside prompt): ${u}`
          )), s && s(P.IS_DISMISSED_MOMENT, u);
        }
        c && (document.cookie = "g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT");
      });
    };
    w && (j(), t(!0));
  }, [
    w,
    r,
    i,
    o,
    a,
    c,
    l,
    E,
    s
  ]), null;
}, un = "Google One Tap";
var nn = /* @__PURE__ */ ((e) => (e.PROMPT_DISPLAYED = "Prompt Displayed", e.PROMPT_NOT_DISPLAYED = "Prompt Not Displayed", e))(nn || {}), tn = /* @__PURE__ */ ((e) => (e.NOT_DISPLAYED = "User Sign-In Attempted", e.SIGNED_IN = "User Sign-In Succeeded", e.DISMISSED = "User Sign-In Dismissed", e.SKIPPED = "User Sign-In Skipped", e))(tn || {});
export {
  P as GoogleOneTapNotification,
  un as TRACKING_CATEGORY,
  tn as TRACKING_EVENT_NAMES,
  nn as TRACKING_LABELS,
  cn as VistaGoogleOneTap
};
